import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { overrideAdminFeatureFlagByCustomerIdSlice } from './overrideDefault';
import { useDefaultAdminFeatureFlagByCustomerIdSlice } from './useDefault';

export const adminFeatureFlagByCustomerIdReducers = combineReducers({
	override: overrideAdminFeatureFlagByCustomerIdSlice.asyncReducers,
	useDefault: useDefaultAdminFeatureFlagByCustomerIdSlice.asyncReducers
});

export const adminFeatureFlagByCustomerIdWatchers = combineAllWatchers([
	overrideAdminFeatureFlagByCustomerIdSlice.asyncWatchers,
	useDefaultAdminFeatureFlagByCustomerIdSlice.asyncWatchers
]);
